<div class="layout-search-panel p-input-filled">
  <a
    #searchIcon
    pStyleClass="@next"
    enterFromClass="ng-hidden"
    enterActiveClass="px-scalein"
    leaveToClass="ng-hidden"
    leaveActiveClass="px-fadeout"
    [hideOnOutsideClick]="true"
  >
    <i class="pi pi-search"></i>
  </a>
  <div class="ng-hidden">
    <input
      type="text"
      #searchInput
      pInputText
      [placeholder]="'searchPlaceholder' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE }"
      [(ngModel)]="filter"
      (ngModelChange)="handleFilterChanged($event)"
    />
    <button
      pButton
      [class.hidden-button]="!filter"
      type="button"
      icon="pi pi-times"
      class="p-button-rounded p-button-text p-button-plain"
      (click)="resetFilter()"
    ></button>
    <pfx-global-search-overlay class="flex">
      <div [class.loading]="isLoading">
        @if (!isFilterProcessable) {
          <div class="global-search-explanation">
            <div>
              <img
                src="assets/images/search.svg"
                [alt]="'search' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE }"
                priority
              />
            </div>
            <div>
              <p>
                {{ 'searchExplanation' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
              </p>

              <p class="text-sm">
                {{ 'hint' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}:
                {{ 'exactSearchExplanationBefore' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
                <strong>!</strong>
                {{ 'exactSearchExplanationAfter' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
              </p>

              <p class="text-sm">
                {{ 'escExplanationBefore' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
                <strong>esc</strong>
                {{ 'escExplanationAfter' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
              </p>
            </div>
          </div>
        } @else {
          @if (globalSearchResult) {
            <pfx-global-search-result-wrapper
              [globalSearchResult]="globalSearchResult"
              [isLoading]="isLoading"
              [selectedIndex]="selectedIndex"
            ></pfx-global-search-result-wrapper>
          }
        }

        @if (!filter && searchHistory.length > 0) {
          <div class="search-history-section">
            <h3 class="history-title">
              {{ 'recentSearches' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
            </h3>
            <div class="history-list">
              @for (item of searchHistory; track item; let i = $index) {
                <pfx-global-search-result-item
                  [item]="item"
                  [isLoading]="false"
                  [isHistoryItem]="true"
                  [isSelected]="isItemSelected(i)"
                  (deleteItem)="deleteHistoryItem($event)"
                ></pfx-global-search-result-item>
              }
            </div>
          </div>
        }
      </div>
    </pfx-global-search-overlay>
  </div>
</div>
